<template lang="pug" src="./upload-csv.pug"> </template>
<style lang="scss" src="./upload-csv.scss" scoped> </style>

<script>
export default {
    data: () => ({
        file: null,
        isSelecting: false,
    }),
    computed: {
        uploadText() {
            return this.file && this.file.name ||
                `${this.$vuetify.lang.t('$vuetify.buttons.upload')} .csv`;
        },
    },
    watch: {
        isSelecting(val) {
            if (!val) {
                window.removeEventListener('focus', this.focusHandler);
            }
        }
    },
    methods: {
        onFileChanged(event) {
            const file = event.target.files[0];

            if (file && file.type !== 'text/csv') {
                this.$store.dispatch('alert/addMessage', {
                    message: 'invalidFormat'
                }, { root: true });
            } else {
                this.file = file;
                this.$emit('onFileSelect', file);
            }
        },

        onUpload() {
            this.isSelecting = true;
            window.addEventListener('focus', this.focusHandler);
            this.$refs.uploader.click();
        },

        focusHandler() {
            this.isSelecting = false;
        }
    }
};
</script>
